import { createReducer, on } from "@ngrx/store";
import * as dashboardActions from "./dashboard.actions";

export const dashboardFeatureKey = "dashboardData";

export interface DashboardState {
  dashboardData: any;
  allocatedProjects: any;
  selectedProject: any;
  loading: boolean;
  error: any;
}

export const initialState: DashboardState = {
  dashboardData: null,
  allocatedProjects: null,
  selectedProject: null,
  loading: false,
  error: null,
};

export const dashboardReducer = createReducer(
  initialState,
  on(dashboardActions.loadDashboardData, (state) => ({
    ...state,
    loading: true,
  })),
  on(dashboardActions.loadDashboardDataSuccess, (state, { dashboardData }) => ({
    ...state,
    loading: false,
    dashboardData,
  })),
  on(dashboardActions.loadDashboardDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  // Allocated Projects
  on(dashboardActions.loadAllocatedProjects, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    dashboardActions.loadAllocatedProjectsSuccess,
    (state, { allocatedProjects }) => ({
      ...state,
      allocatedProjects,
      loading: false,
    })
  ),
  on(dashboardActions.loadAllocatedProjectsFailure, (state, { error }) => ({
    ...state,
    allocatedError: error,
    loading: false,
  })),
  on(dashboardActions.setSelectedProject, (state, { selectedProject }) => ({
    ...state,
    selectedProject,
  })),
  // RESET on logout
  on(dashboardActions.logout, () => initialState)
);
